import { Navigate, useLocation } from 'react-router-dom';

/** Redirects legacy portal login URLs to unified identity login. */
export function LegacyPortalRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/identity/login${search}`} replace />;
}
